<template>
  <div>
    <Breadcrumbs
      :breadcrumbs="[
     {title: this.$t(`menu.${serviceSlug}`), disabled: true},
     {title: this.$t('menu.iframe/biosigns-management'), disabled: true}
   ]">
      <div slot="breadcrumbAfter" v-if="tabValue===1" class="d-flex align-items-center">
        <va-popover
          v-if="canCreateCodes"
          class="mr-2"
          placement="left"
          :message="$t('biosigns.accessCodes.createCodes')">
          <i class="icon-fa fa-solid fa-plus" @click.prevent="showCreateCodesModal = true"></i>
        </va-popover>
        <va-popover
          placement="left"
          :message="$t('statistics2.ops_stats.downloadExcel')">
          <span class="icon i-cloud-download" @click.prevent="downloadExcelAccessCodes"></span>
        </va-popover>
      </div>
    </Breadcrumbs>

    <va-tabs v-model="tabValue" style="border-width: 2px; margin-bottom: 15px">
      <va-tab v-for="tab in tabViews" :key="tab">
        {{ tab === 'accessCodes' ? $t("biosigns.accessCodes.title") : $t("biosigns.packs.title") }}
      </va-tab>
    </va-tabs>

    <!--View for PACKS -->
    <div v-if="tabValue === 0">
      <FadeTransition
        v-if="canCreateCodes"
        :duration="400"
        mode="out-in">
        <div class="btn btn__floating btn__round__large btn__round__large">
          <va-popover
            :message="$t('biosigns.packs.createPack')"
            placement="left"
          >
            <va-button
              @click.prevent="showCreateOrUpdatePackModal = true">
              <i class="fa fa-plus"></i>
            </va-button>

          </va-popover>

        </div>
      </FadeTransition>

      <div class="row">
        <div class="col-4">
          <div class="mt-2">
            <label class="form-label">{{$t('iframe.table_headings.client')}}:</label>
            <multiselect
              v-model="packsFilters.entities"
              :options="clientOptions"
              track-by="id"
              label="name"
              :custom-label="formatedEntityLabel"
              select-label=""
              selected-label=""
              deselect-label=""
              :placeholder="$t('iframe.table_headings.client')"
              :allow-empty="true"
              :multiple="false"
              :searchable="true"
              :disabled="clientOptions.length <= 1">
              <template slot="clear">
                <span class="multiselect__clear" v-if="packsFilters.entities"
                      @mousedown.prevent.stop="packsFilters.entities = null"></span>
              </template>
            </multiselect>
          </div>

          <div class="mt-3">
            <label class="form-label">{{$t('biosigns.accessCodes.statusesTitle')}}:</label>
            <multiselect
              v-model="packsFilters.statuses"
              :options="packsStatusesOptions"
              track-by="id"
              label="name"
              select-label=""
              selected-label=""
              deselect-label=""
              :placeholder="$t('biosigns.accessCodes.statusesTitle')"
              :allow-empty="true"
              :multiple="true"
              :searchable="true">
              <template slot="clear">
                <span class="multiselect__clear" v-if="packsFilters.statuses"
                      @mousedown.prevent.stop="packsFilters.statuses = null"></span>
              </template>
            </multiselect>
          </div>
        </div>
        <div class="col-8">
          <BiosignsStatsComponent class="pl-5 mt-3 mb-4" :filters.sync="packsFilters" :hidden="['accessCodes']"/>
        </div>
      </div>
      <div>
        <BiosignsScanPacksTable
          :component="component"
          :serviceSlug="serviceSlug"
          ref="iframeBiosignalsScanPacksTable"
          :showFilters.sync="showFilters"
          :customQueries="customQueries"
          :clientOptions="clientOptions"
          :filters.sync="packsFilters"
          @handleUpdatePack="handleUpdatePack"
          @refreshTable="handleRefreshPacksTable"
        />

        <CreateOrUpdateScanPacksModal
          v-if="showCreateOrUpdatePackModal && canCreateCodes"
          :selectedPack="selectedPack"
          :clientOptions="clientOptions"
          @cancel="handleCancelPacks"
          @submitted="onCreatedUpdatedPacks"
        />
      </div>

    </div>
    <!--View for ACCESS CODES -->
    <div v-else>
      <FadeTransition
        v-if="canCreateCodes"
        :duration="400"
        mode="out-in">
        <div class="btn btn__floating btn__round__large btn__round__large">
          <va-popover
            :message="$t('biosigns.accessCodes.createCodes')"
            placement="left"
          >
            <va-button
              @click.prevent="showCreateCodesModal = true">
              <i class="fa fa-plus"></i>
            </va-button>

          </va-popover>

        </div>
      </FadeTransition>

      <div class="row mt-2 no-gutters evollu-form">

        <div class="row">
          <div class="col-4">
            <div class="mt-2">
              <div>
                <label class="form-label">{{$t('iframe.table_headings.client')}}:</label>
                <multiselect
                  v-model="accessCodesFilters.entities"
                  :options="clientOptions"
                  track-by="id"
                  label="name"
                  :custom-label="formatedEntityLabel"
                  select-label=""
                  selected-label=""
                  deselect-label=""
                  :placeholder="$t('iframe.table_headings.client')"
                  :allow-empty="true"
                  :multiple="false"
                  :searchable="true"
                  :disabled="clientOptions.length <= 1">
                  <template slot="clear">
                <span class="multiselect__clear" v-if="accessCodesFilters.entities"
                      @mousedown.prevent.stop="accessCodesFilters.entities = null"></span>
                  </template>
                </multiselect>
              </div>
            </div>
            <div class="mt-3">
              <div>
                <label class="form-label">{{$t('biosigns.accessCodes.statusesTitle')}}:</label>
                <multiselect
                  v-model="accessCodesFilters.statuses"
                  :options="accessCodesStatusesOptions"
                  track-by="id"
                  label="name"
                  select-label=""
                  selected-label=""
                  deselect-label=""
                  :placeholder="$t('biosigns.accessCodes.statusesTitle')"
                  :allow-empty="true"
                  :multiple="true"
                  :searchable="true">
                  <template slot="clear">
                <span class="multiselect__clear" v-if="accessCodesFilters.statuses"
                      @mousedown.prevent.stop="accessCodesFilters.statuses = null"></span>
                  </template>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="col-8">
            <BiosignsStatsComponent class="pl-5 mt-3 mb-4" :filters.sync="accessCodesFilters" :hidden="['packs']"/>
          </div>

        </div>
      </div>

      <BiosignsAccessCodesTable
        :component="component"
        :serviceSlug="serviceSlug"
        ref="iframeBiosignalsAccessCodes"
        :showFilters.sync="showFilters"
        :customQueries="customQueries"
        :clientOptions="clientOptions"
        :filters.sync="accessCodesFilters"
      />

      <CreateAccessCodesModal
        v-if="showCreateCodesModal && canCreateCodes"
        :clientOptions="clientOptions"
        @cancel="handleCancel"
        @created="onCreated"
      />
    </div>

  </div>
</template>
<script>
import Breadcrumbs from '@/components/common/Breadcrumbs.vue';
import Filters from '@/components/common/Filters.vue';
import { TABLE_IFRAME_BIOSIGNALS_ACCESS_CODES } from '@/local-storage/LocalStorageKeys';
import IndexTablesMixin from '@/mixins/IndexTablesMixin.vue';
import BiosignsAccessCodesTable from '@/components/iframe/biosigns-management/BiosignsAccessCodesTable.vue';
import { IframeService } from '@/api/IframeService';
import FadeTransition from '@/components/common/transitions/FadeTransition.vue';
import CreateAccessCodesModal from '@/components/iframe/biosigns-management/CreateAccessCodesModal.vue';
import CreateContactBlock from '@/components/iframe/blocks-builder/contact/CreateContactBlock.vue';
import BiosignsStatsComponent from '@/components/iframe/biosigns-management/BiosignsStatsComponent.vue';
import Multiselect from 'vue-multiselect';
import LocalStorageHelper from '@/local-storage/LocalStorageHelper';
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter.vue';
import ClustersAndEntitiesMixin from '@/mixins/ClustersAndEntitiesMixin.vue';
import BiosignsScanPacksTable from '@/components/iframe/biosigns-management/BiosignsScanPacksTable.vue';
import CreateOrUpdateScanPacksModal from '@/components/iframe/biosigns-management/CreateOrUpdateScanPacksModal.vue';

export default {
  components: { CreateOrUpdateScanPacksModal, BiosignsScanPacksTable, Multiselect, BiosignsStatsComponent, CreateContactBlock, CreateAccessCodesModal, FadeTransition, BiosignsAccessCodesTable, Filters, Breadcrumbs },
  mixins: [
    IndexTablesMixin,
    MultiselectLabelFormatter,
    ClustersAndEntitiesMixin
  ],
  props: {
    component: {
      type: Object,
      required: true
    },
    serviceSlug: {
      type: String,
      required: true
    },
  },
  data () {
    return {
      tabValue: 0,
      tabViews: ['packs', 'accessCodes'],
      showFilters: false,
      activeFilters: 0,
      localStorageKey: TABLE_IFRAME_BIOSIGNALS_ACCESS_CODES,
      customQueries: null,
      packsFilters: {
        entities: null,
        statuses: null
      },
      accessCodesFilters: {
        entities: null,
        statuses: null,
      },
      showCreateCodesModal: false,
      accessCodesStatusesOptions: [
        {
          id: 1,
          name: this.$t('biosigns.accessCodes.statuses.active'),
          slug: 'active'
        },
        {
          id: 2,
          name: this.$t('biosigns.accessCodes.statuses.used'),
          slug: 'used'
        },
        {
          id: 3,
          name: this.$t('biosigns.accessCodes.statuses.expired'),
          slug: 'expired'
        }
      ],
      packsStatusesOptions: [
        {
          id: 1,
          name: this.$t('biosigns.packs.statuses.active'),
          slug: 'active'
        },
        /*{
          id: 2,
          name: this.$t('biosigns.packs.statuses.inactive'),
          slug: 'inactive'
        },*/
        {
          id: 3,
          name: this.$t('biosigns.packs.statuses.expired'),
          slug: 'expired'
        }
      ],
      showCreateOrUpdatePackModal: false,
      selectedPack: null
    }
  },
  async mounted() {
    //this.loadLocalStorage()
  },
  methods: {
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
    handleUpdatePack: function(pack) {
      this.selectedPack = pack
      this.showCreateOrUpdatePackModal = true
    },
    handleCancelPacks: function () {
      this.showCreateOrUpdatePackModal = false
      this.selectedPack = null
    },
    onCreatedUpdatedPacks: function(data) {
      this.$refs.iframeBiosignalsScanPacksTable.$refs.iframeBiosignalsScanPacksTable.refresh()
      this.showCreateOrUpdatePackModal = false
      this.selectedPack = null
    },
    handleRefreshPacksTable: function() {
      this.$refs.iframeBiosignalsScanPacksTable.$refs.iframeBiosignalsScanPacksTable.refresh()
    },
    handleCancel: function () {
      this.showCreateCodesModal = false
    },
    onCreated: function (data) {
      //this.$refs.iframeBiosignalsAccessCodes.$refs.iframeBiosignalsAccessCodes.data.push(...data)
      this.$refs.iframeBiosignalsAccessCodes.$refs.iframeBiosignalsAccessCodes.refresh()
      this.showCreateCodesModal = false
    },
    downloadExcelAccessCodes: function () {
      let params = {}

      if(this.accessCodesFilters.entities) {
        params.entities = this.accessCodesFilters.entities.id
      }
      if(this.accessCodesFilters.statuses && this.accessCodesFilters.statuses.length > 0) {
        params.statuses = this.accessCodesFilters.statuses.map(status => status.slug).join(',')
      }

      params.ascending = 1
      params.orderBy = 'validUntil'

      this.isExportingExcelToast = this.showToast(this.$t('biosigns.accessCodes.exporting'), {
        ...this.$store.state.successToastOptions,
        icon: 'cloud-download',
        duration: null
      })

      IframeService.downloadBiosignsAccessCodesExcel(params).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'biosigns_access_codes.xlsx')
        document.body.appendChild(link)
        link.click()
        this.isExportingExcelToast.goAway(100)
      }).catch(err => {
        console.log(err)
        this.isExportingExcelToast.goAway(100)
        setTimeout(() => {
          this.showToast(this.$t('statistics2.ops_stats.downloadExcelGenericFailure'), this.$store.state.errorToastOptions)
        }, 500)
      }).finally(() =>{
        this.isExportingExcelToast = null
      })

    },
    /*loadLocalStorage: function () {
      let state = LocalStorageHelper.get(TABLE_IFRAME_BIOSIGNALS_ACCESS_CODES)
      if (state) {
        if (Object.values(state.customQueries).some(object => object !== '')) {
          //if (state.customQueries.entities && state.customQueries.entities !== '') {
          //  const entIds = state.customQueries.entities.split(',').map(id => parseInt(id))
          //  this.filters.entities = this.authorizedEntities.filter(entities => entIds.includes(parseInt(entities.id)) )
          //}
          if(this.clientOptions.length) {
            this.filters.entities = this.clientOptions.find(entity => entity.id === state.customQueries.entities)
          }

          if (state.customQueries.statuses && state.customQueries.statuses !== '') {
            this.filters.statuses = state.customQueries.statuses
              .split(',')
              .filter(st => this.statusesOptions.some(sto => sto.slug === st))
              .map(st => this.statusesOptions.find(sto => sto.slug === st))
          }
        }
      }
    },*/
  },
  computed: {
    clientOptions: function() {
      if(this.component &&  this.component.service && this.component.service.user_permissions.length > 0) {
        let perms = this.component.service.user_permissions.filter(perm => perm.info_type === 130)
        if(perms && perms.length > 0) {
          if(perms.some(perm => perm.entity_id === null)) {
            return this.component.service.entities
          } else {
            const entitiesIds = perms.map(perm => perm.entity_id)
            return this.component.service.entities.filter(ent => entitiesIds.includes(ent.id))
          }
        }
      }
      return []
    },
    canCreateCodes: function() {
      if(this.component && this.component.service && this.component.service.user_permissions.length > 0) {
        let perms = this.component.service.user_permissions.filter(perm => perm.info_type === 130)

        if(perms && perms.length > 0) {
          return perms.some(perm => perm.access_type >= 2)
        }
      }
      return false
    }
  },
  watch: {

  }
}
</script>
<style scoped>
.icon-fa {
  font-size: 24px;

  &:hover {
    color: #29C4AA;
  }
}


:deep(.va-tab:nth-of-type(2)) {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

:deep(.va-tab:last-of-type) {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.va-tab {
  border: 2px solid rgb(41, 196, 169);
}

.va-tab--active {
  background: rgb(41, 196, 169);
  color: white;
}
</style>
